import Vue from 'vue'
import App from './globalsearch.vue'
import axios from 'axios'
import VueCarousel from 'vue-carousel';
import vmodal from 'vue-js-modal'
Vue.use(vmodal)
Vue.use(VueCarousel)

// VueYouTube
import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)

Vue.config.productionTip = false
window.axios = require('axios');
var els = document.getElementsByClassName('searchBar2021')

Array.prototype.forEach.call(els, function(el) {
  console.log(el.dataset.noshop)
  new Vue({
    render : h => h(App),
    name: 'globalsearch',
    data: {
      language : JSON.parse(el.dataset.language),
      iscompany: (el.dataset.iscompany != 'N'),
      channel : el.dataset.channel,
      deviceType : el.dataset.searchdevice,
      attributeset : window.M_AttributeSet_ID,
      articleSectionId : el.dataset.articlesectionid,
      isNutriverse : (el.dataset.isnutriverse == "true"),
      isWebshop: (el.dataset.noshop != 'Y')
    }
  }).$mount(el)
});
